import comp from "./RubricTableV2";
export default comp;
